import { __assign } from "tslib";
export var authSettingsApiRelativePath = "/helpcenter/auth";
export var createAuthSettingsApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(authSettingsApiRelativePath);
    return {
        getSettings: function (brandId) {
            return http.get("".concat(apiUrl).concat(brandId ? "?brandId=".concat(brandId) : ''));
        },
        updateSettings: function (dto) {
            return http.put("".concat(apiUrl), dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
    };
};
//# sourceMappingURL=index.js.map